import { Box, Flex, Button } from '@hausgold/designsystem';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { ApiContext, WizardContext } from '../../../utils/contexts.js';
import { getBackButtonText, getNextButtonText } from '../../../services/models/dialog.js';
import ProgressBarCTA from './ProgressBarCTA.js';
import { jsx } from '@emotion/react';
var CustomNavigationButtons = function CustomNavigationButtons(_ref) {
  var totalSteps = _ref.totalSteps,
    currentStepIndex = _ref.currentStepIndex,
    nextStepKey = _ref.nextStepKey,
    handlePreviousButtonClick = _ref.handlePreviousButtonClick,
    handleNextButtonClick = _ref.handleNextButtonClick;
  var _useContext = useContext(ApiContext),
    data = _useContext.data;
  var _useContext2 = useContext(WizardContext),
    NavigationButtonsLayoutContainer = _useContext2.components.NavigationButtonsLayoutContainer;
  return jsx(NavigationButtonsLayoutContainer, {
    flexDirection: "column"
  }, jsx(Box, {
    textAlign: "center"
  }), jsx(Box, {
    width: "100%"
  }, jsx(Flex, {
    width: "100%",
    justifyContent: currentStepIndex >= 0 ? 'space-between' : 'flex-end',
    mb: 4
  }, currentStepIndex >= 0 && jsx(Button, {
    variant: "outline",
    colorScheme: "blue",
    as: "a",
    className: "back",
    onClick: handlePreviousButtonClick
  }, getBackButtonText(data)), jsx(Button, {
    colorScheme: "red",
    backgroundColor: "rgb(244, 99, 100)",
    borderColor: "rgb(244, 99, 100)",
    as: nextStepKey ? 'a' : 'button',
    type: nextStepKey ? null : 'submit',
    className: "next",
    onClick: handleNextButtonClick
  }, getNextButtonText(data))), jsx(ProgressBarCTA, {
    currentStepIndex: currentStepIndex,
    totalSteps: totalSteps
  })));
};
CustomNavigationButtons.propTypes = {
  totalSteps: PropTypes.number.isRequired,
  currentStepIndex: PropTypes.number.isRequired,
  nextStepKey: PropTypes.string.isRequired,
  handlePreviousButtonClick: PropTypes.func.isRequired,
  handleNextButtonClick: PropTypes.func.isRequired
};
export { CustomNavigationButtons as default };